// removed by extract-text-webpack-plugin
module.exports = {"hamburger-icon":"src-components----HamburgerIcon-module---hamburger-icon---2JR6F","bar":"src-components----HamburgerIcon-module---bar---um3Yi","open":"src-components----HamburgerIcon-module---open---5gRTG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HamburgerIcon.module.scss
// module id = 656
// module chunks = 114276838955818